import {
  // Collapse,
  IconButton,
  List,
  ListItem,
  Typography,
  Box,
} from "@mui/material";
import genericStyles from "../Styles/genericStyles.module.css";
import styles from "../Styles/mainSlider.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Fragment, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { mainPathMatches } from "../Utils/Utils";
import { MainSliderProps } from "../Utils/Types";
import withRole from "../Hooks/withRole";

function MainSlider(props: MainSliderProps, location: any) {
  location = useLocation();
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const [selectedKey, setSelectedKey] = useState<null | number>(null);

  /**
   *
   * @param element
   * @param key
   * @param shouldCollapse
   * @returns
   */
  const renderListItem = (element: any, key: any, shouldCollapse: boolean) => {
    return (
      <ListItem
        key={key}
        className={styles.listItem}
        onClick={(e) => {
          if (shouldCollapse) {
            e.stopPropagation();
            handleChangeCollapse(key);
          } else {
            handleNavigate(element.path);
          }
        }}
      >
        <IconButton
          className={
            mainPathMatches(element.path, location.pathname)
              ? genericStyles.selected
              : genericStyles.nonSelected
          }
        >
          {element.icon}
        </IconButton>
        <div className={styles.arrowContainer}>
          <Typography
            className={
              mainPathMatches(element.path, location.pathname)
                ? genericStyles.selectedText
                : genericStyles.nonSelectedText
            }
          >
            {element.name}
          </Typography>
          {shouldCollapse ? (
            collapse && selectedKey === key ? (
              <KeyboardArrowDown />
            ) : (
              <KeyboardArrowUp />
            )
          ) : null}
        </div>
      </ListItem>
    );
  };

  /**
   * Function to handle the collapse of the list
   */
  const handleChangeCollapse = (key: null | number) => {
    if (key === selectedKey) {
      setCollapse(!collapse);
    } else {
      setCollapse(true);
      setSelectedKey(key);
    }
  };

  /**
   *
   * @param path
   */
  const handleNavigate = (path: string) => {
    // Check if we're already on the same path
    if (location.pathname === path) {
      // If we're on the same path, don't navigate (preserve existing URL params)
      props.setHideSlider();
      return;
    }
    navigate(path);
    props.setHideSlider();
  };

  return (
    <Box className={styles.container}>
      <div className={styles.mobileHeader} />
      <div className={styles.slider}>
        <List>
          {props.data?.map((element: any, key: any) => {
            return element.children ? (
              <Fragment key={key}>
                {renderListItem(element, key, true)}
                {collapse && selectedKey === key && (
                  <List className={styles.selectedTextSubMenu}>
                    {element.children.map((child: any, childKey: any) => {
                      return (
                        <ListItem
                          key={childKey}
                          className={styles.nestedListItem}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleNavigate(child.path);
                          }}
                        >
                          <IconButton
                            className={
                              mainPathMatches(child.path, location.pathname)
                                ? genericStyles.selected
                                : genericStyles.nonSelected
                            }
                            size="small"
                          >
                            {child.icon}
                          </IconButton>
                          <Typography
                            className={
                              mainPathMatches(child.path, location.pathname)
                                ? genericStyles.selectedText
                                : genericStyles.nonSelectedText
                            }
                          >
                            {child.name}
                          </Typography>
                        </ListItem>
                      );
                    })}
                  </List>
                )}
              </Fragment>
            ) : (
              renderListItem(element, key, false)
            );
          })}
        </List>
      </div>
    </Box>
  );
}

export default withRole(MainSlider);
